import { Radio } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Spinner } from '@/components/ui'
import { ModuleEmptyPage } from '@/components/layout/ModuleEmptyPage'
import { useCurrentTenant } from '@/features/tenants/useCurrentTenant'

import { ChannelsList } from './components/ChannelsList'

/**
 * Tela de Canais: o usuario ve seus canais de atendimento (hoje: WhatsApp), o status de conexao de
 * cada um sempre visivel e pode reconectar via QR quando um canal cai. Vocabulario neutro
 * (docs/design/00 s5): nunca expoe provider/instancia/inbox nem infraestrutura.
 */
export function ChannelsPage() {
  const { t } = useTranslation()
  const { tenant, isLoading } = useCurrentTenant()

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Spinner label={t('loading')} />
      </div>
    )
  }

  if (tenant === null) {
    return (
      <ModuleEmptyPage
        icon={Radio}
        title={t('modules.channels.title')}
        description={t('modules.channels.description')}
      />
    )
  }

  return (
    <div className="mx-auto flex w-full max-w-4xl flex-col gap-6">
      <header className="flex flex-col gap-1">
        <h1 className="text-xl font-semibold text-foreground-primary">{t('channels.pageTitle')}</h1>
        <p className="text-sm text-foreground-muted">{t('channels.pageSubtitle')}</p>
      </header>
      <ChannelsList tenantId={tenant.id} />
    </div>
  )
}
